import { TaskCompletion } from 'graphql-common';
import _get from 'lodash/get';
import { TFunction } from 'i18next';
import Icons from '@lib/components/Icons/Icons';
import { NavItem, NavItemTypeEnum } from '@lib/components/Menu/Menu';

const getTaskReportingTableActionsMenu = ({
  t,
  onViewTaskCompletionHandler,
  onCreateIntervention,
  onViewIntervention,
}: {
  t: TFunction<'translation', undefined>;
  onViewTaskCompletionHandler: (item?: TaskCompletion) => void;
  onCreateIntervention: (item?: TaskCompletion) => void;
  onViewIntervention: (item?: TaskCompletion) => void;
}): NavItem<TaskCompletion>[] => {
  return [
    {
      id: 'view-action',
      title: t('view'),
      onClick: (item) => onViewTaskCompletionHandler(item),
      leftIcon: Icons.view,
      type: NavItemTypeEnum.Secondary,
    },
    {
      id: 'create-intervention',
      title: t('create-intervention'),
      onClick: onCreateIntervention
        ? (item) => onCreateIntervention(item)
        : undefined,
      leftIcon: Icons.build,
      type: NavItemTypeEnum.Secondary,
      predictorFnVisible: (item) =>
        !!_get(item, 'task.canInterventionCreate.value'),
    },
    {
      id: 'view-intervention',
      title: t('view-intervention'),
      onClick: onViewIntervention
        ? (item) => onViewIntervention(item)
        : undefined,
      leftIcon: Icons.build,
      type: NavItemTypeEnum.Secondary,
      predictorFnVisible: (item) => !!_get(item, 'intervention.id'),
    },
  ];
};

export default getTaskReportingTableActionsMenu;
